"use strict";

var Backbone = require("backbone");
var _ = require("underscore");

/**
 * BaseModel : add a flag when model is fetching/fetched
 */

module.exports = Backbone.Model.extend({

    hasChangedSinceLastSync: false,

    fetched: false,
    fetching: false,
    token: null,
    cookie: null,
    mtime: 0,
    withCredentials: false,

    initialize: function (attributes, options) {
        Backbone.Model.prototype.initialize.apply(this, arguments);

        // on autorise l'injection de ajax et jquery pour que la classe puisse être utilisée aussi côté server
        if (options) {
            if (options.jQuery) {
                Backbone.$ = options.jQuery;
            }
            if (options.ajax) {
                Backbone.ajax = options.ajax;
            }
        }
    },

    fetch: function (options) {
        var T = this,
            new_options = options ? _.clone(options) : {},
            success_cb = new_options.success,
            error_cb = new_options.error;

        if (T.withCredentials) {
            new_options.xhrFields = new_options.xhrFields || {};
            new_options.xhrFields.withCredentials = true; // pour autoriser les cookies avec les requêtes ajax
        }

        T.fetching = true;
        new_options.success = function (model, response, options) {
            T.fetched = true;
            T.fetching = false;
            if (success_cb) {
                success_cb(model, response, options);
            }
        };
        new_options.error = function (model, response, options) {
            T.fetching = false;
            if (error_cb) {
                error_cb(model, response, options);
            }
        };

        return Backbone.Model.prototype.fetch.call(T, new_options);
    },

    sync: function (method, model, options) {
        var T = this,
            new_options = options ? _.clone(options) : {};

        if (!new_options.headers) {
            new_options.headers = {};
        }

        if (T.token) {
            new_options.headers["x-access-token"] = T.token;
        }

        if (T.cookie) {
            new_options.headers.cookie = T.cookie;
        }

        var success = new_options.success;
        new_options.success = function (resp) {
            if (success) {
                success(resp);
            }
            model.hasChangedSinceLastSync = false;
        };

        return Backbone.Model.prototype.sync.call(T, method, model, new_options);
    },

    addQueryStringArrayToUrl:function(base_url,query_string){
        if(query_string.length){
            base_url+="?"+query_string.join("&");
        }
        return base_url;
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/common/models/base-model.js
// module id = 6
// module chunks = 0